import Paper from "@mui/material/Paper";
import colors from "../assets/scss/_themes-vars.module.scss";
import { darken, lighten, styled } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { Button, CircularProgress, Backdrop, Grid, alpha } from "@mui/material";
import { Navigate } from "react-router-dom";
import React from "react";
import { ArrowUpward } from "@mui/icons-material";
import Lottie from "lottie-react";
import FileTransfer_Animation from "../animations/FileTransfer_Animation.json";

export const getDateFormat = (strdate) => {
  var db_date = "";
  if (strdate !== null) {
    var tdate = new Date(strdate);
    const day = ("0" + tdate.getDate()).slice(-2);
    const month = ("0" + (tdate.getMonth() + 1)).slice(-2);
    db_date = day + "/" + month + "/" + tdate.getFullYear();
  }
  return db_date;
};

export const getDateTimeFormat = (strdate) => {
  let db_date = "";
  if (strdate !== null) {
    const tdate = new Date(strdate);
    const day = ("0" + tdate.getDate()).slice(-2);
    const month = ("0" + (tdate.getMonth() + 1)).slice(-2);
    const year = tdate.getFullYear();
    const hours = ("0" + tdate.getHours()).slice(-2);
    const minutes = ("0" + tdate.getMinutes()).slice(-2);

    db_date = `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  return db_date;
};

export const getDateFormatUS = (strdate) => {
  var db_date = "";
  if (strdate !== null) {
    var tdate = new Date(strdate);
    const day = ("0" + tdate.getDate()).slice(-2);
    const month = ("0" + (tdate.getMonth() + 1)).slice(-2);
    db_date = tdate.getFullYear() + "/" + month + "/" + day;
  }
  return db_date;
};

export const AutocompleteX = {
  display: "inline-block",
  width: "100%",
};

export const Mandatory = () => {
  return <span className="mandatoryStar">*</span>;
};

export const SubmitSuccess = (redirect, pathname, ButtonName) => {
  return redirect ? (
    <Navigate to={pathname} />
  ) : (
    <Grid item>
      <Button variant="contained" disabled>
        {" "}
        {ButtonName}{" "}
      </Button>
      <Backdrop 
        open={true} 
        sx={{
            ...BackdropStyles(),
              zIndex: (theme) => theme.zIndex.modal - 1,
            }}
      >
        {/* <CircularProgress color="inherit" sx={CircularProgressStyles()}/> */}
        <Lottie
          animationData={FileTransfer_Animation}
          loop
          autoplay
          style={{ width: 250, height: 250 }}
        />
      </Backdrop>
    </Grid>
  );
};

export const waitingTime = () => {
  return 4000;
};

export function errorHandling(response, setError) {
  if (response) {
    if (response.status == 401) {
      setError(
        <span style={{ color : "#ff4d4d" }}>
          You are not Authorized, Please Check Session or Login Again
        </span>
      );
    } else if (response.status == 404) {
      setError(
        <span style={{ color : "#ff4d4d" }}>The Requested Content Not Found</span>
      );
    } else if (response.status == 500) {
      setError(
        <span style={{ color : "#ff4d4d" }}>
          Internal Server Error, Please Contact Admin
        </span>
      );
    } else if (response.status == 400) {
      setError(
        <span style={{ color : "#ff4d4d" }}>Please Provide Valid Information</span>
      );
    }
  }
  if (!navigator.onLine) {
    setError(
      <span style={{ color : "#ff4d4d" }}>
        No Internet Connection, Please check your network connection and try
        again
      </span>
    );
  }
}

// export function ButtonStyles(theme) {
//   return {
//     background: "linear-gradient(90deg, #ff5c6b, #ff8f50)",
//     color: theme.palette.themeMode === "dark" ? "#fff" : "#0A0A0A",
//     fontSize: "14px",
//     borderRadius: "8px",
//     position: "sticky",
//     top: 0,
//     margin: "5px",
//   };
// }

export function ButtonStyles(theme) {
  return {
    background: "#129EA3",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "8px",
    border: "none",
    alignItems: "center",
    boxShadow: `0 4px 20px ${alpha("#558b9aff", 0.2)}`,
    letterSpacing: "1px",
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    margin: "5px",
    gap: "10px",
    bottom: "5px",
  };
}

export function UploadButton() {
  return {
    background: "#129EA3",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "10px",
    boxShadow: `0 4px 20px ${alpha("#558b9aff", 0.2)}`,
    letterSpacing: "1px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    top: "1px",
    bottom: "5px",
    "&:hover": {
      backgroundColor: "#91887e",
    },
  };
}

export function ListItemsStyles(theme) {
  return {
    padding: "0px 10px",
    marginTop: "5px",
    borderRadius: "10px",
      background: theme.palette.themeMode == "dark" ? "#2c2b4c82" : "#87cefa",

    [theme.breakpoints.down("sm")]: {
      padding: "0px 6px",
      marginTop: "3px",
      borderRadius: "6px",
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "0px 12px",
      marginTop: "6px",
      borderRadius: "10px",
      fontSize: "14px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "0px 16px",
      marginTop: "8px",
      borderRadius: "12px",
      fontSize: "15px",
    },
  };
}

export function BackdropStyles() {
  return {
    zIndex: 9999,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  };
}

export function CircularProgressStyles() {
  return {
    zIndex: 10000,
  };
}

export function ReportTableStyles(theme) {
  return {
    border: "1px solid grey",
    borderRadius: "5px",
    backgroundColor:
      theme.palette.themeMode === "dark"
        ? theme.palette.primary.light
        : "#fff",
    overflowY: "auto",
    flexGrow: 1,
    position: "relative",

    maxHeight: "calc(100vh - 220px)",

    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100vh - 160px)",
      borderRadius: "3px",
    },

    [theme.breakpoints.up("md")]: {
      maxHeight: "calc(100vh - 180px)",
    },

    [theme.breakpoints.up("lg")]: {
      maxHeight: "calc(100vh - 140px)",
    },

    [theme.breakpoints.up("xl")]: {
      maxHeight: "calc(100vh - 100px)",
    },

    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
  };
}

export function TableHeaderStyles(theme) {
  return {
    textAlign: "center",
    fontSize: "17px",
    width: "auto",
    fontWeight: "600",
    backgroundColor:
      theme.palette.themeMode == "dark"
        ? "#1D2029"
        : "#1976D2",
    color:
      theme.palette.themeMode == "dark"
        ? "#FDFEFA"
        : "rgba(0, 0, 0, 0.5)",
    border: "1px solid #575757",

    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      padding: "4px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "15px",
      padding: "6px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
      padding: "8px",
    },
  };
}

export function DialogStyles(theme) {
  return {
    "& .MuiDialog-paper": {
      width: "100%",
      borderRadius: "8px",
      backgroundColor: theme.palette.themeMode == "dark" ? "#353551" : "fff",

      [theme.breakpoints.down("sm")]: {
        width: "95%",
        borderRadius: "6px",
      },
      [theme.breakpoints.up("md")]: {
        width: "80%",
      },
      [theme.breakpoints.up("lg")]: {
        width: "60%",
      },
    },
  };
}

export const toYearFormat = ((strdate) => {
  var db_date = ''
  if (strdate !== null){
      var tdate = new Date(strdate);
        db_date = tdate.getFullYear()+'-'+(tdate.getMonth()+1)+'-'+tdate.getDate();
  }
  return db_date
});

export const normalizeFilename = (nameOrUrl) => {
  if (!nameOrUrl || typeof nameOrUrl !== "string") return "";

  let name = nameOrUrl.includes("/") ? nameOrUrl.split("/").pop() : nameOrUrl;

  name = name.toLowerCase().trim();

  const parts = name.split(".");
  let ext = parts.length > 1 ? "." + parts.pop().toLowerCase() : "";
  let base = parts.join(".");

  base = base
    .replace(/\s+/g, "_")
    .replace(/[^A-Za-z0-9._-]/g, "")
    .replace(/^\.+/, "")

  if (ext && base.endsWith(ext)) {
    base = base.slice(0, -ext.length);
  }

  return base + ext;
};

export function handleApiError(error, setErrorMessage, setErrorDialog, setErrorType) {
  console.error("API Error:", error);

  if (error.code === "ECONNABORTED") {
    return { retry: true };
  }

  if (!error.response) {
    if (!navigator.onLine) {
      setErrorMessage("Network connection lost. Please check your internet.");
      setErrorType("network");
    } else {
      setErrorMessage("Unable to reach the server at the moment. Please try again shortly or contact the administrator.");
      setErrorType("server");
    }
    setErrorDialog(true);
    return;
  }

  if (error.response.status >= 500) {
    setErrorMessage("The server encountered an issue while processing your request. Please try again or contact the administrator.");
    setErrorType("server");
    setErrorDialog(true);
    return;
  }

  setErrorMessage("Request failed due to a server issue. Please try again or contact the administrator.");
  setErrorType("server");
  setErrorDialog(true);
}


